import ListGroup from './ListGroup'
import MobileContent from './MobileContent'
import Week from './Week'
import ListFilter from './ListFilter'
// import UshkDatepicker from './Datepicker'

const components = {
  ListGroup,
  MobileContent,
  Week,
  ListFilter
  // UshkDatepicker
}

export default function install (Vue) {
  Object.keys(components).forEach(key => {
    Vue.component(key, components[key])
  })
}



// WEBPACK FOOTER //
// ./src/views/calendar/modules/index.js